import React from "react";
import { ClientType } from "../../types";
import { CopyClientModal } from "./copy-client-modal";
import { Button } from "../ui/button";
import { Copy } from "lucide-react";

interface CopyClientButtonProps {
  client: ClientType;
  variant?: "default" | "outline" | "ghost";
  size?: "default" | "sm" | "lg" | "icon";
  showIcon?: boolean;
  showText?: boolean;
  className?: string;
  onSuccess?: (newClientId: number) => void;
}

/**
 * Copy Client Button - Wrapper component for easy integration
 * 
 * Usage:
 * ```tsx
 * <CopyClientButton client={client} />
 * <CopyClientButton client={client} variant="outline" size="sm" />
 * <CopyClientButton client={client} showIcon={false} />
 * ```
 */
export function CopyClientButton({
  client,
  variant = "outline",
  size = "default",
  showIcon = true,
  showText = true,
  className = "",
  onSuccess,
}: CopyClientButtonProps) {
  return (
    <CopyClientModal
      client={client}
      onSuccess={onSuccess}
      trigger={
        <Button 
          variant={variant} 
          size={size}
          className={`copy-client-button ${className}`}
        >
          {showIcon && <Copy className="h-4 w-4" />}
          {showText && (
            <span className={showIcon ? "ml-2" : ""}>
              Copy Client
            </span>
          )}
        </Button>
      }
    />
  );
}

